import { configureStore } from "@reduxjs/toolkit";
import SmeSlice from "../function-components/Redux/SmeSlice";
import BundleSkillsSlice from "../function-components/Redux/BundleSkillsSlice";
import BussinessPOCSlice from "../function-components/Redux/BussinessPOCSlice";
import THSlice from "../function-components/Redux/THSlice";
import AdminUserSlice from "../function-components/Redux/AdminUserSlice";
import TrackSlice from "../function-components/Redux/TrackSlice";
import THUserMaintenance from "../function-components/Redux/THUserMaintenance";
import deliveryLeadershipSlice from "../Tracks/DeliveryLeadership/app/DeliveryLeadershipSlice";

export default configureStore({
 reducer: {
  sme: SmeSlice,
  poc: BussinessPOCSlice,
  traininghost: THSlice,
  adminUser: AdminUserSlice,
  tracks: TrackSlice,
  thAdminUser : THUserMaintenance,
  bundleSkills:BundleSkillsSlice,
  deliveryLeadership: deliveryLeadershipSlice
 },
});
